import apiInstance from '../services/apiInstance';

export const usePdfActions = () => {
    const parsePdf = async (formData: FormData) => {
        const response = await apiInstance.post('/pdf-parser', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    };

    const compressPdf = async (formData: FormData) => {
        const response = await apiInstance.post('/pdf-compress', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            responseType: 'blob',
        });
        return response.data;
    };

    return { parsePdf, compressPdf };
};
